export default __webpack_public_path__ + "static/media/cif-by.bf006122.svg";